export const MAX_NODE_DISK_MIB = 2_147_483_647;
export const DISK_GUARD_ENTER_MIB = 2 * 1024;
export const DISK_GUARD_ENTER_PERCENT = 3;
export const DISK_GUARD_RECOVER_MIB = 3 * 1024;
export const DISK_GUARD_RECOVER_PERCENT = 5;

export type NodeDisk = { diskTotalMib: number; diskAvailableMib: number };
export type DiskPressure = "normal" | "hold" | "evacuate";

/** Incomplete or invalid observations never stand in for a measured empty disk. */
export function hasNodeDisk(value: {
  diskTotalMib?: number | null;
  diskAvailableMib?: number | null;
}): value is NodeDisk {
  const { diskTotalMib: total, diskAvailableMib: available } = value;
  return (
    typeof total === "number" &&
    Number.isInteger(total) &&
    total > 0 &&
    total <= MAX_NODE_DISK_MIB &&
    typeof available === "number" &&
    Number.isInteger(available) &&
    available >= 0 &&
    available <= total
  );
}

export function nextDiskGuard(active: boolean, disk: NodeDisk): boolean {
  const floor = active ? DISK_GUARD_RECOVER_MIB : DISK_GUARD_ENTER_MIB;
  const percent = active ? DISK_GUARD_RECOVER_PERCENT : DISK_GUARD_ENTER_PERCENT;
  return disk.diskAvailableMib < Math.max(floor, (disk.diskTotalMib * percent) / 100);
}

export function sellableStorageMib(storageMib: number, percent: number): number {
  return Math.floor((storageMib * percent) / 100);
}
